var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ScrollSpy extends Component {
    constructor() {
        super('ScrollSpy', false);
        this.headerHeight = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.sections = $('.hw-scrollspy-section');
            this.links = $('.hw-scrollspy-menu a');
            this.links.on('click', (event, link) => {
                event.preventDefault();
                $.scrollTo($(link.attr('href')).position().y + -this.headerHeight, 500);
                $('#page-navigation').removeClass('is-opened');
            });
            $(window).on('scroll', () => {
                this.spy();
            });
            $(window).on('resize', () => {
                this.updateHeaderHeight();
            });
            // Target anchor
            const scrollTarget = location.hash.includes('#section-') ? location.hash.replace('section-', '') : null;
            setTimeout(() => {
                $(`a[href^='${scrollTarget}']`).trigger('click');
            }, 1000);
            this.updateHeaderHeight();
            this.spy();
            // Navigation menu
            $('#btn-toggle-page-navigation').on('click', () => {
                $('#page-navigation').toggleClass('is-opened');
            });
            $('#page-navigation').css('--items-count', $('#page-navigation a:not(#btn-toggle-navigation)').length);
            $(window).on('resize', () => {
                this.updateNavigationHeight();
            });
            this.updateNavigationHeight();
            // Restore scroll position from hash
            scrollTo(0, 0);
            setTimeout(() => {
                if (location.hash) {
                    const target = $(location.hash);
                    if (target.length) {
                        $.scrollTo(target.position().y - this.headerHeight);
                    }
                }
            }, 1000);
            // Finish
            this.success();
        });
    }
    spy() {
        let currentID = $('body').hasClass('single-book') || $('body').hasClass('single-people') ? this.sections.eq(0).attr('id') : '';
        this.sections.each((section) => {
            if (Math.floor(section.viewportPosition().y) <= this.headerHeight + 32)
                currentID = $(section).attr('id');
        });
        if (currentID && this.links.search('[href="#' + currentID + '"]').length > 0) {
            this.links.removeClass('bg-primary text-white').search('[href="#' + currentID + '"]').addClass('bg-primary text-white');
            $('#btn-toggle-page-navigation').text(this.links.search('[href="#' + currentID + '"]').text());
            if (currentID !== 'informations' && currentID != '')
                history.replaceState(null, null, '#' + currentID);
        }
        $('#page-navigation').removeClass('is-opened');
    }
    updateHeaderHeight() {
        this.headerHeight = $('.header').height() + ($(window).width() < 1200 ? 24 : $('.book-title .position-fixed, .people-title .position-fixed').height() + 32);
    }
    updateNavigationHeight() {
        $('#page-navigation').css('--line-height', $('#page-navigation a').eq(0).height() + 'px');
    }
}
